import { Component, OnInit } from '@angular/core';
import { CmxLayoutService } from '../../services/cmx-layout.service';

@Component({
  selector: 'cmx-mobile-app-selector',
  templateUrl: './cmx-mobile-app-selector.component.html',
  styleUrls: ['./cmx-mobile-app-selector.component.scss'],
})
export class CmxMobileAppSelectorComponent implements OnInit {
  constructor(public layout: CmxLayoutService) {}

  ngOnInit() {}

  onClose() {
    this.layout.isMobileAppSelectorOpen.next(false);
  }

  onItemClick(id: number | string) {
    this.layout.isMobileAppSelectorOpen.next(false);
    this.layout.appMenuClick.emit(id);
  }
}
